import { MenuItem } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom-v5-compat";
import Skeleton from "react-loading-skeleton";
import {
  ActionBar,
  ActionBarButtons,
  ActionDropdownButton,
  DeleteActionButton,
  EditActionButton,
  DetailsActionButton,
} from "../ActionBar";

import { accessRightsShape, nodeShape } from "../../shapes";

import { rulesShape, withRules } from "../../context";

import { url } from "../../utils";

import Heading from "../Heading";
import AllObjectsBadge from "./AllObjectsBadge";
import { useSubscriptionQuery } from "../../hooks";

type Props = {
  accessRights?: accessRightsShape;
  additionalCreateMenuItems?: React.ReactNode;
  isLoading: boolean;
  node?: nodeShape;
  rules: rulesShape;
  onConfirmDelete?: $TSFixMeFunction;
  isParentNode?: boolean;
};

export function AllObjectsHeader({
  accessRights,
  additionalCreateMenuItems,
  isLoading,
  node,
  rules,
  onConfirmDelete,
  isParentNode,
}: Props) {
  const intl = useIntl();
  // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type '{}'.
  const { id: nodeId } = useParams();
  const navigate = useNavigate();
  const { data: subscription } = useSubscriptionQuery();

  const handleOnCreateClick = (key: $TSFixMe) => {
    switch (key) {
      case "create_asset":
        navigate(
          nodeId
            ? url(`/nodes/${nodeId}/assets/create`)
            : url("/assets/create"),
        );
        break;
      case "create_node":
        navigate(
          nodeId ? url(`/nodes/${nodeId}/create`) : url("/nodes/create"),
        );
        break;
      case "create_tag":
        navigate(
          nodeId
            ? url(`/nodes/${nodeId}/instrumentations/create`)
            : url("/instrumentations/create"),
        );
        break;
      case "scan_asset":
        navigate(
          nodeId
            ? url(`/nodes/${nodeId}/assets/create_scan`)
            : url("/assets/create_scan"),
        );
        break;
      /* istanbul ignore next */
      default:
        break;
    }
  };

  const editTarget = nodeId ? `/nodes/${nodeId}/edit` : "/404";
  const detailsTarget = nodeId ? `/nodes/${nodeId}/details` : "/404";

  const nodeDetailsButton = node ? (
    // @ts-expect-error TS(2322) FIXME: Type '{ id: string; target: string; }' is not assi... Remove this comment to see the full error message
    <DetailsActionButton id="details-node-button" target={detailsTarget} />
  ) : null;

  const editButton = node ? (
    <EditActionButton
      id="edit-node-button"
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      disabled={!accessRights.canUpdate || !rules.node(node).get("editable")}
      target={editTarget}
    />
  ) : null;

  const deleteButton = node ? (
    <DeleteActionButton
      id="delete-node-button"
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      disabled={isParentNode || !accessRights.canDelete || isLoading}
      modalTitle={intl.formatMessage({ id: "node.actions.delete.modal_title" })}
      modalMessage={intl.formatMessage({
        id: "node.actions.delete.modal_message",
      })}
      onConfirm={onConfirmDelete}
    />
  ) : null;

  const scanAssetButton = rules.application().get("showScanAssetButton") ? (
    <MenuItem
      className="icon icon-eh-show-less"
      eventKey="scan_asset"
      id="scan-asset-menu-item"
      disabled={
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        subscription?.asset_quota > 0 &&
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        subscription?.number_assigned_assets >= subscription?.asset_quota
      }
      onSelect={handleOnCreateClick}
    >
      <FormattedMessage id="dropdown_scan.asset" />
    </MenuItem>
  ) : null;

  const loader = (
    <Skeleton width={80} containerTestId="allObjectsHeader-skeleton" />
  );

  const title = () => {
    if (!!nodeId && isLoading) return loader;
    return node?.name ?? intl.formatMessage({ id: "nodes.header" });
  };

  return (
    <ActionBar>
      <Heading level={1} className="heading-badge" title={title()}>
        <AllObjectsBadge />
      </Heading>
      <ActionBarButtons>
        {nodeDetailsButton}
        {deleteButton}
        {editButton}
        <ActionDropdownButton
          // @ts-expect-error TS(2322) FIXME: Type '{ children: (ReactNode | Element)[]; id: str... Remove this comment to see the full error message
          id="create-button"
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          disabled={node ? !accessRights.canUpdate : false}
          icon="icon-eh-new"
          title={intl.formatMessage({ id: "button.create" })}
        >
          <MenuItem
            className="icon icon-eh-show-less"
            eventKey="create_asset"
            id="create-asset-menu-item"
            disabled={
              // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
              subscription?.asset_quota > 0 &&
              // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
              subscription?.number_assigned_assets >= subscription?.asset_quota
            }
            onSelect={handleOnCreateClick}
          >
            <FormattedMessage id="dropdown_create.asset" />
          </MenuItem>
          {scanAssetButton}
          <MenuItem
            className="icon icon-eh-show-less"
            eventKey="create_tag"
            id="create-tag-menu-item"
            onSelect={handleOnCreateClick}
          >
            <FormattedMessage id="dropdown_create.tag" />
          </MenuItem>
          {additionalCreateMenuItems}
          <MenuItem
            className="icon icon-eh-show-less"
            eventKey="create_node"
            id="create-node-menu-item"
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            disabled={node && !accessRights.canUpdate}
            onSelect={handleOnCreateClick}
          >
            <FormattedMessage id="dropdown_create.node" />
          </MenuItem>
        </ActionDropdownButton>
      </ActionBarButtons>
    </ActionBar>
  );
}

export default withRules(AllObjectsHeader);
